export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';